import { AGENT_SCENARIOS_CRUD_ACTION_CONSTANTS as CRUD_ACTION_CONSTANTS } from '../actions/agent_scenarios_actions';
import { standardInitialStateGenerator, standardReducerGenerator } from './standard_reducer_utils';

// `GET /scenarios` is the only way to enumerate procedures, so this slice backs
// the AOP list page. Records are scenario entries keyed by scenario id.
/*
  Two collections, not one.

  `agentScenariosIndex` is the list page's, and it is paged. `aopProcedureScenario`
  is a lookup — "which scenario routes to this procedure" — which reads the
  slice's own `records` and only needs a collection because the thunk takes one.
  Both are declared here because an undeclared name makes
  `getRecordsForTargetCollection` throw, and sharing the list's meant an
  unpaginated read overwriting its page and its count.

  There was a third, `radarProcedureNames`, for "what is this procedure called".
  The service puts `procedure_name` on a run now, so nothing asks.
*/
const initialState: any = standardInitialStateGenerator([
	'agentScenariosIndex',
	'aopProcedureScenario',
]);
export default standardReducerGenerator(CRUD_ACTION_CONSTANTS, initialState);
